/**
 * Banner popup'ındaki video oynatma yardımcıları (saf; DOM/React bağımlılığı yok).
 * Tarayıcılar sesli otomatik oynatmayı engellediği için tüm videolar sessiz başlar;
 * kullanıcı sesi oynatıcıdan açar.
 */

/** BannerType 7 = YouTube, 8 = Vimeo (`IBannerTypeEnum`). */
export const BANNER_TYPE_YOUTUBE = 7
export const BANNER_TYPE_VIMEO = 8

const YOUTUBE_ID = /^[A-Za-z0-9_-]{6,}$/

/** `VideoId` alanı tam URL / youtu.be / shorts / embed biçiminde de gelebilir; kimliğe indirger. */
const extractYoutubeId = (value: string): string | null => {
  const raw = value.trim()
  if (!raw) return null
  const patterns = [
    /youtu\.be\/([A-Za-z0-9_-]+)/,
    /[?&]v=([A-Za-z0-9_-]+)/,
    /youtube(?:-nocookie)?\.com\/(?:shorts|embed|live|v)\/([A-Za-z0-9_-]+)/,
  ]
  for (const pattern of patterns) {
    const match = raw.match(pattern)
    if (match) return match[1]
  }
  return YOUTUBE_ID.test(raw) ? raw : null
}

export function youtubeEmbedUrl(videoId: string): string | null {
  const id = extractYoutubeId(videoId || '')
  if (!id) return null
  return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&playsinline=1&rel=0`
}

/**
 * Vimeo `VideoId`: `123456`, `123456/abcd`, `123456?h=abcd` ya da tam URL olabilir.
 * Gizli (unlisted) videoların hash'i varsa `h=` olarak eklenir; sabit hash kullanılmaz.
 */
export function vimeoEmbedUrl(videoId: string): string | null {
  const raw = (videoId || '').trim()
  if (!raw) return null
  const hashParam = raw.match(/[?&]h=([A-Za-z0-9]+)/)
  const path = raw.split(/[?#]/)[0]
  const pathMatch = path.match(/(?:^|\/)(\d+)(?:\/([A-Za-z0-9]+))?\/?$/)
  if (!pathMatch) return null
  const id = pathMatch[1]
  const hash = hashParam ? hashParam[1] : pathMatch[2]
  const params = `${hash ? `h=${hash}&` : ''}autoplay=1&muted=1&playsinline=1`
  return `https://player.vimeo.com/video/${id}?${params}`
}

/** Dosya adı `.mp4` ile bitiyorsa (büyük/küçük harf fark etmez) true. */
export function isMp4(file?: string | null): boolean {
  if (!file) return false
  return /\.mp4(?:$|[?#])/i.test(file.trim())
}

/** Popup açma koşulu: görsel **veya** (YouTube/Vimeo tipi ve `VideoId`). */
export function hasPopupContent(b: { Image?: string; BannerType: number; VideoId?: string }): boolean {
  if (b.Image && b.Image.trim()) return true
  const isEmbedType = b.BannerType === BANNER_TYPE_YOUTUBE || b.BannerType === BANNER_TYPE_VIMEO
  return isEmbedType && !!(b.VideoId && b.VideoId.trim())
}
